export var createAnimationFrame = function createAnimationFrame(emitNotSupportedError, window, wrapSubscribeFunction) {
  return function () {
    return wrapSubscribeFunction(function (observer) {
      if (window === null || window.cancelAnimationFrame === undefined || window.requestAnimationFrame === undefined) {
        return emitNotSupportedError(observer);
      }
      var animationFrameHandle = window.requestAnimationFrame(function animationFrameCallback(timestamp) {
        animationFrameHandle = window.requestAnimationFrame(animationFrameCallback);
        observer.next(timestamp);
      });
      return function () {
        return window.cancelAnimationFrame(animationFrameHandle);
      };
    });
  };
};